import { SteppedEase, gsap } from 'gsap';

import { gsapTimelineFunc } from '../gsap-config';

export const scrapbookA: gsapTimelineFunc = (targets) => {
  return gsap
    .timeline({ defaults: { ease: SteppedEase.config(1) } })
    .fromTo(
      targets,
      { duration: 0, opacity: 0, translateX: 0, rotateZ: -20 },
      {
        duration: 0.3,
        translateY: '200%',
        rotateZ: 20,
        opacity: 1,
        translateX: '-75%',
      }
    )
    .to(targets, {
      duration: 0.2,
      translateY: '150%',
      translateX: '75%',
      rotateZ: -50,
    })
    .to(targets, {
      duration: 0.2,
      translateY: '100%',
      translateX: '-50%',
      rotateZ: 30,
    })
    .to(targets, {
      duration: 0.1,
      translateY: '50%',
      translateX: '50%',
      rotateZ: -5,
    })
    .to(targets, {
      duration: 0.1,
      translateY: '50%',
      translateX: '-25%',
      rotateZ: 15,
    })
    .to(targets, {
      duration: 0.1,
      translateY: '0%',
      translateX: 0,
      rotateZ: 0,
    });
};
